"use strict";

var _interopRequireDefault = require("/www/wwwroot/node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/node/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _vuex = require("vuex");
var _request = _interopRequireDefault(require("@/utils/request"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default
  },
  data: function data() {
    return {
      search: '',
      // 顶部搜索框form数据
      formInline: {
        keyword: '' //搜索关键词
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    }
  }),
  methods: {
    handleClick: function handleClick(item) {
      this.$router.push({
        name: 'shopDetail',
        query: {
          id: item.id
        }
      });
    },
    handleFilter: function handleFilter(e) {
      // this.$refs.target.handleFilter()
      this.listLoading = true;
      this.formInline.keyword = e.target.value;
      // 调用子组件的goSearch方法
      this.$refs.target.getList();
      //   this.$refs.target.goSearch( this.formInline.keyword )
    },
    onSubmitShop: function onSubmitShop(shop_id, status) {
      var _this = this;
      // 提交数据给后端
      (0, _request.default)({
        url: "/system/customer/updateInfo/",
        method: 'put',
        data: {
          status: status,
          shop_id: shop_id
        }
      }).then(function (response) {
        if (response.code == 200) {
          _this.dialogVisibleshop = false;
          _this.getList1(); //重新获取商家数据
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};